var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isScreenReady
    ? _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.shouldShowMarkerInfo && !_vm.isMarkerInfoActive,
              expression: "shouldShowMarkerInfo && !isMarkerInfoActive",
            },
          ],
          staticClass: "viewer-markers-hover",
          style: _vm.markerInfoPosition,
        },
        [
          _c(
            "div",
            {
              staticClass: "viewer-markers-hover-inner",
              on: {
                mouseover: _vm.htmlMarkerMousein,
                mouseleave: _vm.htmlMarkerMouseout,
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.currentMarker.type === "point" ||
                        _vm.currentMarker.type === "teleport",
                      expression:
                        "currentMarker.type === 'point' || currentMarker.type === 'teleport'",
                    },
                  ],
                },
                [
                  _c(
                    "div",
                    { staticClass: "viewer-markers-hover-thumbnail" },
                    [
                      _c("icon", {
                        staticClass: "viewer-markers-hover-thumbnail-inner",
                        attrs: {
                          image: _vm.nextPanorama.thumbnail,
                          "has-lazyload": true,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "viewer-markers-hover-text" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.nextCategory) + "\n      "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: [
                        "tag",
                        "popup",
                        "arMakerTag",
                        "videoplay",
                        "pdf",
                      ].includes(_vm.currentMarker.type),
                      expression:
                        "['tag', 'popup', 'arMakerTag', 'videoplay', 'pdf'].includes(currentMarker.type)",
                    },
                  ],
                },
                [
                  _vm.currentMarker.nameMulti &&
                  _vm.currentMarker.nameMulti[_vm.lang]
                    ? _c("p", { staticClass: "viewer-markers-hover-text" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.currentMarker.nameMulti[_vm.lang]) +
                            "\n      "
                        ),
                      ])
                    : _c("p", { staticClass: "viewer-markers-hover-text" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.currentMarker.name) +
                            "\n      "
                        ),
                      ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.currentMarker.type === "videoplay" &&
                        !_vm.isVideoPreviewing,
                      expression:
                        "currentMarker.type === 'videoplay' && !isVideoPreviewing",
                    },
                  ],
                  staticClass: "video-setting",
                },
                [
                  _vm.favoritesMarkerTypes.includes(_vm.currentMarker.type)
                    ? _c("i-favorite", {
                        attrs: { category: "marker", item: _vm.currentMarker },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "player-button",
                      on: { click: _vm.toggleVideoPause },
                    },
                    [
                      _c("i", {
                        staticClass: "isif",
                        class: {
                          "isif-play": _vm.isVideoplayPaused,
                          "isif-pause": !_vm.isVideoplayPaused,
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "player-button",
                      on: {
                        click: function ($event) {
                          return _vm.toggleVideoMuted(!_vm.isVideoplayMuted)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "isif",
                        class: {
                          "isif-volume-mute": _vm.isVideoplayMuted,
                          "isif-volume-on": !_vm.isVideoplayMuted,
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("i-slider", {
                    attrs: {
                      min: 0,
                      max: 100,
                      direction: "vertical",
                      value: _vm.videoplayVolume,
                    },
                    on: { input: _vm.setVideoplayVolume },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "decoration" }),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }